import { OnInit, ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '../../services/app.service';
import { LessonObservationService } from '../../services/lesson-observation.service';
import { ILessonObservation } from '../../models/LessonObservation';
import { LessonObservationEditComponent } from './edit.component';

@Component({
    selector: 'app-lesson-observation-form',
    templateUrl: './form.component.html'
})
export class LessonObservationFormComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: LessonObservationService,
        private route: ActivatedRoute
    ) { }

    data?: ILessonObservation;
    returnTo?: string;

    isReady: boolean;
    isEdit: boolean;

    onClose: (saved: boolean) => void;

    @ViewChild('editForm', { static: false }) editForm: LessonObservationEditComponent;

    ngOnInit() {
        const id = +this.route.snapshot.params['id'];        
        const canEdit = this.app.currentUser.hasRight('LESSON_OBSERVATION.EDIT');

        if (id) {
            this.app.addLoading(this.service.getById(id)).subscribe(data => {
                this.data = data;

                this.isEdit = (canEdit && (data.Status == 'Draft' || data.Status == 'Rejected'));

                this.isReady = true;
            });
        } else {
            this.isEdit = true;
            this.isReady = true;
        }
    }

    onEdit() {
        this.onClose = saved => {
            this.isEdit = false;

            if (saved) {
                this.app.addLoading(this.service.getById(this.data.Id)).subscribe(data => {
                    this.data = data;
                });
            }
        };

        this.isEdit = true;
    }
}
